import { useContext } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import WorkUsers from '@atom/components/common/workUsers/WorkUsers';
import WorkTemplateContext from '@atom/components/workTemplate/WorkTemplateContext';
import { WorkTemplateTaskItem } from '@atom/types/workTemplate';
import timeUtilities from '@atom/utilities/timeUtilities';

import classes from './workTemplateTasks.module.css';

interface Props {
  task: WorkTemplateTaskItem;
}

const TaskListItem = ({ task }: Props) => {
  const { task: activeTask, setActiveTask } = useContext(WorkTemplateContext);

  return (
    <>
      <div
        className={clsx(
          classes.taskListItemContainer,
          activeTask && task.id === activeTask.id && classes.selected,
        )}
        onClick={() => setActiveTask(task.id)}
      >
        <div className={classes.taskListContentContainer}>
          <div className={classes.taskTitle}>{task.name}</div>
          {R.isEmpty(task.users) && R.isEmpty(task.userGroups) ? (
            <div className={classes.noAssigneesMessage}>No Assignees</div>
          ) : (
            <WorkUsers
              users={task.users as any}
              userGroups={task.userGroups as any}
              avatarSize={32}
            />
          )}
          <div className={classes.taskDates}>
            <div>{`Due Date: ${timeUtilities.setDisplayDate(
              task.dueDate,
            )}`}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaskListItem;
